var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support-modal-success"},[_c('PxIcon',{staticClass:"support-modal-success__icon",attrs:{"size":90,"name":"email-sent--orange"}}),_c('h3',{staticClass:"support-modal-success__title"},[_vm._v(" "+_vm._s(_vm.$t("common.components.supportModal.successMessage.title"))+" ")]),_c('p',{staticClass:"support-modal-success__message",domProps:{"innerHTML":_vm._s(
      _vm.$t("common.components.supportModal.successMessage.message", {
        email: _vm.email,
      })
    )}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }